import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import { Button, Form, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { Promotora } from '../../shared/model/promotora';
import Spinner from '../../shared/spinner';
import { Container } from './style';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { PontoVendaDTO } from '../../shared/dto/pontoVendaDTO';
import { PromotoraEmpregadorDTO } from '../../shared/dto/promotoraEmpregadorDTO';
import { Orgao } from '../../shared/model/orgao';
import { RiCalculatorLine } from 'react-icons/ri';
import { BiDollar } from 'react-icons/bi';
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { FaCheck } from 'react-icons/fa'
import { Financiamento } from '../../shared/model/financiamento';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import { addDays, format, isValid, max, parse, parseISO } from 'date-fns';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import { CalculoResultadoSimulacaoDTO } from '../../shared/dto/calculoResultadoSimulacaoDTO';
import { ResultadoSimulacaoPropostaDTO } from '../../shared/dto/resultadoSimulacaoPropostaDTO';
import { PropostaDTO } from '../../shared/dto/propostaDTO';
import { Cliente } from '../../shared/model/Cliente';
import { useNavigate } from 'react-router-dom';
import PropostaService from '../../services/propostaService';
import PromotoraService from '../../services/promotoraService';
import OriginadorService from '../../services/originadorService';
import PontoVendaService from '../../services/pontoVendaService';
import EmpregadorService from '../../services/empregadorService';
import FinanciamentoService from '../../services/financiamentoService';
import PromotoraEmpregadorService from '../../services/promotoraEmpregadorService';
import CustomAlert from '../../shared/customAlert';
import { TiposProposta } from '../../shared/constantes/tiposProposta';
import ClienteService from '../../services/clienteService';
import { RefinDTO } from '../../shared/dto/refinDTO';
import OperacaoParcelaService from '../../services/operacaoParcelaService';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { TiposProduto } from '../../shared/constantes/tiposProduto';
import { PROPOSTAS_POR_PRODUTO } from '../../shared/constantes/PROPOSTAS_POR_PRODUTO';
import BancoService from '../../services/bancoService';
import { Banco } from '../../shared/model/banco';
import { Originador } from '../../shared/model/originador';
import { CompraDividaDTO } from '../../shared/dto/compraDividaDTO';
import { TipoPagamentoEnum } from '../../shared/constantes/tipoPagamentoEnum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPencil } from '@fortawesome/free-solid-svg-icons';
import { ButtonAlterar } from '../../shared/buttons';
import OrigemService from '../../services/origemService';
import DateInput from '../../shared/dateInput';

interface DadosBancarios {
  tipoConta: string;
  codigoBanco: string;
  agencia: string;
  dvAgencia: string;
  conta: string;
  dvConta: string;
}

function CartaoComponent() {



  const getUsuarioLogadoRobust = () => {
    const storageRole = localStorage.getItem('role') || sessionStorage.getItem('role');
    const storageId = localStorage.getItem('id') || sessionStorage.getItem('id');
    const storageNome = localStorage.getItem('nome') || sessionStorage.getItem('nome');

    const pdvId = localStorage.getItem('pontoVendaId') ||
      sessionStorage.getItem('pontoVendaId') ||
      storageId;

    if (storageRole) {
      return {
        id: storageId,
        role: storageRole,
        nome: storageNome,
        pontoVendaId: pdvId
      };
    }
    const localStr = localStorage.getItem('usuario_sessao');
    if (localStr) {
      try { return JSON.parse(localStr); } catch (e) { }
    }
    return null;
  };

  const usuarioLogado = getUsuarioLogadoRobust();
  const role = usuarioLogado?.role ? usuarioLogado.role.toUpperCase() : '';

  const isUsuarioPDV = role.includes('PONTO_VENDA') || role.includes('PONTO DE VENDA') || role === 'ROLE_PONTO_VENDA';
  const isUsuarioPromotora = role.includes('PROMOTORA') || role.includes('ROLE_PROMOTORA');


  const isUsuarioRestrito = isUsuarioPDV || isUsuarioPromotora;

  useVerificaPermissao();
  const [promotora, setPromotora] = useState('');

  useEffect(() => {
    const carregarContextoPontoVenda = async () => {
      if (!isUsuarioRestrito) {
        try {
          const resp = await origemService.listarOrigens().catch(() => ({ data: [] }));
          let listaOrigens = resp.data || [];
          
          if (listaOrigens.length === 0) {
            const resPromo = await promotoraService.listarTodasPromotorasAtivasPorRole().catch(() => ({ data: [] }));
            const promoData = resPromo.data || [];
            if (promoData.length > 0) {
              const mapOrigens = new Map();
              promoData.forEach((p: any) => {
                if (p.matriz) mapOrigens.set(`MATRIZ_${p.matriz}`, { id: `MATRIZ_${p.matriz}`, nome: (p.nomeMatriz || 'Matriz') + ' - Matriz', tipoOrigem: 'MATRIZ' });
                else if (p.idOriginador) mapOrigens.set(`CONSIGNATARIA_${p.idOriginador}`, { id: `CONSIGNATARIA_${p.idOriginador}`, nome: (p.nomeOriginador || 'Originador') + ' - Consignatária', tipoOrigem: 'CONSIGNATARIA' });
              });
              listaOrigens = Array.from(mapOrigens.values());
            }
          }
          
          const ativosResp = await originadorService.listarTodosOriginadoresAtivos();
          const idsAtivos = new Set((ativosResp.data as Originador[]).map(item => String(item.id)));
          listaOrigens = listaOrigens.filter((item: any) => item.tipoOrigem !== 'CONSIGNATARIA' || idsAtivos.has(String(item.id).replace('CONSIGNATARIA_', '')));
          setOrigens(listaOrigens);
          setOrigemSelecionada('0');
        } catch (err) { console.error(err); }
        
        listarTodosBancos();
        return;
      }

      try {
        setLoading(true);
        const response = await pontoVendaService.meuContexto();
        const dto: any = response.data;

        if (isUsuarioPDV && !dto.ativo) {
          setAlert({ message: 'Erro impeditivo: Ponto de Venda inativo.', type: 'error' });
          return;
        }
        if (dto.originador) {
          const ativosResp = await originadorService.listarTodosOriginadoresAtivos();
          if (!(ativosResp.data as Originador[]).some(item => String(item.id) === String(dto.originador))) {
            setAlert({ message: 'Erro impeditivo: Consignatária inativa.', type: 'error' });
            return;
          }
          const org = { id: `CONSIGNATARIA_${dto.originador}`, nome: dto.nomeOriginador, tipoOrigem: 'CONSIGNATARIA' };
          setOrigens([org]);
          setOrigemSelecionada(org.id);
        }

        if (dto.promotora) {
          const prom = { id: dto.promotora, nome: dto.nomePromotora } as Promotora;
          let listaPromotorasUsuario = [prom];

          if (isUsuarioPromotora) {
            const promotorasResp = await promotoraService.listarTodasPromotorasPorRole();
            if (Array.isArray(promotorasResp.data) && promotorasResp.data.length > 0) {
              listaPromotorasUsuario = promotorasResp.data;
            }
          }

          setPromotoras(listaPromotorasUsuario);
          setPromotora(String(dto.promotora));

          listarEmpregadorPorPromotora(dto.promotora);
          if (isUsuarioPromotora) {
            listarPontoVendas(dto.promotora);
          }
        }

        if (dto.id && isUsuarioPDV) {
          setPontoVendas([dto as PontoVendaDTO]);
          setPontoVenda(String(dto.id));
        }

      } catch (error) {
        console.error("Erro no contexto", error);
        setAlert({ message: 'Falha ao carregar perfil.', type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    carregarContextoPontoVenda();
  }, []);

  //const [originadorSelecionado, setOriginadorSelecionado] = useState('');
  const [origemSelecionada, setOrigemSelecionada] = useState('0');

  const origemService: OrigemService = new OrigemService();

  useEffect(() => {
    if (isUsuarioRestrito) return;

    const atualizarPromotoras = async () => {
      setLoading(true);
      try {
        let lista = [];
        
        if (origemSelecionada && origemSelecionada !== '0') {
          const resp = await promotoraService.listarTodasPromotorasAtivasPorRole();
          const [tipo, id] = origemSelecionada.split('_');
          
          lista = (resp.data || []).filter((item: any) => {
            if (tipo === 'MATRIZ') return String(item.matriz || item.idMatriz) === id;
            if (tipo === 'CONSIGNATARIA') return String(item.idOriginador) === id;
            return false;
          });
        }

        setPromotoras(lista);
        setPromotora('0');
        
      } catch (err) { 
        console.error(err); 
      } finally { 
        setLoading(false); 
      }
    };
    
    atualizarPromotoras();
  }, [origemSelecionada]);

  useEffect(() => {
    if (!promotora) return;

    if (isUsuarioPDV) {
      listarEmpregadorPorPromotora(promotora);
      listarOrgaoPorEmpregador(promotora);
      esconderCampos();
      return;
    }

    listarPontoVendas(promotora);
    listarEmpregadorPorPromotora(promotora);
    listarOrgaoPorEmpregador(promotora);
    esconderCampos();
  }, [promotora]);



  useVerificaPermissao();
  const sessaoStr = localStorage.getItem('usuario_sessao');
  const usuarioLogadoDebug = sessaoStr ? JSON.parse(sessaoStr) : null;
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  const navigate = useNavigate();
  const limparNome = (valor: string) => {
    return valor.replace(/[^a-zA-Z\u00C0-\u00FF\s\-\~\^\`\´]/g, "");
  };

  const tipoProposta = TiposProposta;
  const tiposProduto = TiposProduto;

  const [prazos, setPrazos] = useState([]);
  const [promotoras, setPromotoras] = useState<Promotora[]>([]);

  //const [originadorList, setOriginadorList] = useState<Originador[]>([]);
  const [origens, setOrigens] = useState<any[]>([]);

  const [pontoVenda, setPontoVenda] = useState('');
  const [pontoVendas, setPontoVendas] = useState<PontoVendaDTO[]>([]);
  const [tpProposta, setTpProposta] = useState('');
  const [tpProduto, setTpProduto] = useState('');
  const [promotoraEmpregador, setPromotoraEmpregador] = useState<PromotoraEmpregadorDTO[]>([]);
  const [empregador, setEmpregador] = useState('');
  const [codigoMotor, setCodigoMotor] = useState('');
  const [isEmpregadorMargemOnline, setIsEmpregadorMargemOnline] = useState(false);
  const [isMatriculaObrigatoria, setIsMatriculaObrigatoria] = useState(false);
  const [isCodigoAutorizacaoObrigatorio, setIsCodigoAutorizacaoObrigatorio] = useState(false);
  const [orgao, setOrgao] = useState('');
  const [orgaos, setOrgaos] = useState<Orgao[]>([]);
  const [cpf, setCpf] = useState('');
  const [matricula, setMatricula] = useState('');
  const [nome, setNome] = useState('');
  const [dtNascimento, setDtNascimento] = useState('');
  const [codigoAutorizacao, setCodigoAutorizacao] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [valorRMC, setValorRMC] = useState('');
  const [valorRMCOnline, setValorRMCOnline] = useState('');
  const [rmcDisponivel, setRmcDisponivel] = useState(false);
  const [lotacao, setLotacao] = useState('');
  const [secretaria, setSecretaria] = useState('');
  const [situacao, setSituacao] = useState('');
  const [tabelaFinanciamentos, setTabelaFinanciamentos] = useState<Financiamento[]>([]);
  const [idFinanciamentoEscolhido, setIdFinanciamentoEscolhido] = useState('');
  const [financiamento, setFinanciamento] = useState('');
  const [prazo, setPrazo] = useState('');

  const [showResultadoSimulacao, setShowResultadoSimulacao] = useState(false);
  const [valoresSimulacao, setValoresSimulacao] = useState<CalculoResultadoSimulacaoDTO>();

  const [valorParcela, setValorParcela] = useState('0');
  const [valorSolicitado, setValorSolicitado] = useState('0');
  const [resultadoSimulacaoFinal, setResultadoSimulacaoFinal] = useState<ResultadoSimulacaoPropostaDTO>();
  const [dtPrimeiroVencimento, setDtPrimeiroVencimento] = useState('');
  const [dtUltimoVencimento, setDtUltimoVencimento] = useState('');

  const [loading, setLoading] = useState(false);

  const [contratosRefinList, setContratosRefinList] = useState<RefinDTO[]>([]);

  const [mostrarSaldoDevedor, setMostrarSaldoDevedor] = useState(false);
  const [possuiSaldoDevedor, setPossuiSaldoDevedor] = useState(false);
  const [saldoDivida, setSaldoDivida] = useState<CompraDividaDTO>({
    bancoEntidade: '',
    numeroContrato: '',
    saldoDevedor: '',
    prazo: 0,
    parcelasPagas: 0,
    valorParcela: '',
    arquivo: null,
    nomeArquivo: '',
    tipoPagamento: '',
    informacaoPagamento: '',
    selecionado: false,
    tipoConta: '',
    codigoBanco: '',
    agencia: '',
    dvAgencia: '',
    conta: '',
    dvConta: '',
    dataVencimento: addDays(new Date(), 1)
  });
  const [listaSaldoDivida, setListaSaldoDivida] = useState<CompraDividaDTO[]>([]);
  const [bancos, setBancos] = useState<Banco[]>([]);
  const [dadosBancarios, setDadosBancarios] = useState<DadosBancarios>({
    tipoConta: '',
    codigoBanco: '',
    agencia: '',
    dvAgencia: '',
    conta: '',
    dvConta: ''
  })

  const propostaService: PropostaService = new PropostaService();
  const promotoraService: PromotoraService = new PromotoraService();
  const originadorService: OriginadorService = new OriginadorService();
  const pontoVendaService: PontoVendaService = new PontoVendaService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const financiamentoService: FinanciamentoService = new FinanciamentoService();
  const promotoraEmpregadorService: PromotoraEmpregadorService = new PromotoraEmpregadorService();
  const clienteService: ClienteService = new ClienteService();
  const operacaoParcelaService: OperacaoParcelaService = new OperacaoParcelaService();
  const bancoService: BancoService = new BancoService();

  const limiteSaque = valoresSimulacao?.limiteSaque || 0;
  const limiteCompra = valoresSimulacao?.limiteCompra || 0;
  const multiplicadorSaque = valoresSimulacao?.fatorMultiplicadorRmcSaque || 1;
  const multiplicadorCompra = valoresSimulacao?.fatorMultiplicadorRmcCompra || 1;
  const maxSaque = valoresSimulacao?.valorMaxProdutoSaque || 0;
  const maxCompra = valoresSimulacao?.valorMaxProdutoCompra || 0;

  const getUsuarioSessao = () => {
    const id = sessionStorage.getItem('id');
    const role = sessionStorage.getItem('role');
    const nome = sessionStorage.getItem('nome');


    return {
      id: id,
      role: role,
      nome: nome,
      pontoVendaId: null
    };
  };

  const isNomeValido = (nome: string) => {
    const regexNomeCompleto = /^[a-zA-Z\u00C0-\u00FF\s-]{2,}$/;
    return regexNomeCompleto.test(nome.trim());
  };

  const handleNomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valorLimpo = limparNome(e.target.value);
    setNome(valorLimpo);
  };

  const isRgValido = (valorRg: string) => {
    const rgLimpo = valorRg.replace(/[^a-zA-Z0-9]/g, "");
    if (rgLimpo.length < 5 || rgLimpo.length > 14) {
      return false;
    }
    const regexRg = /^[0-9]+[0-9xX]?$/;
    return regexRg.test(rgLimpo);
  };
  const validaEmails = (stringDeEmails: string) => {
    if (!stringDeEmails) return false;
    const lista = stringDeEmails.split(';').map(email => email.trim()).filter(email => email !== "");
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return lista.every(email => regexEmail.test(email));
  };

  const handleMatriculaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valorOriginal = e.target.value;
    const apenasNumeros = valorOriginal.replace(/\D/g, "");
    setMatricula(apenasNumeros);
  };

  let valorMaximoSaque = limiteSaque * multiplicadorSaque;
  if (valorMaximoSaque == 1 || valorMaximoSaque > maxSaque) {
    valorMaximoSaque = maxSaque;
  }
  let valorMaximoCompra = limiteCompra * multiplicadorCompra;
  if (multiplicadorCompra == 1 || valorMaximoCompra > maxCompra) {
    valorMaximoCompra = maxCompra;
  }

  const isEmprestimo =
    tpProduto === 'EMPRESTIMO' ||
    tpProduto === 'ANTECIPACAO_REMUNERACAO';

  const isCompraDivida = tpProposta === 'COMPRA_DIVIDA' || tpProposta === 'COMPRA_DIVIDA_SAQUE';
  const possuiSaldoInformado = listaSaldoDivida?.length > 0;


  const scrowDown = () => {
    setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }, 100);
  }

  interface MyVerticallyCenteredModalProps {
    show: boolean;
    onHide: () => void;
    onModalClose: (valorRMC: string) => void;
  }

  const MyVerticallyCenteredModal: React.FC<MyVerticallyCenteredModalProps> = (props) => {
    const [valorRM, setValorRM] = useState('');
    const [alertModal, setAlertModal] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
    const handleButtonClick = () => {
      if (valorRM === '' || valorRM === undefined) {
        setAlertModal({ message: 'Valor Inválido', type: 'warning' });
        return;
      }

      props.onModalClose(valorRM);
      props.onHide();
    };
    const formatarValorMonetario = (valor: any) => {
      if (!valor) return '0,00';
      const valorComCentavos = valor.padStart(3, '0');
      const reais = valorComCentavos.slice(0, -2);
      const centavos = valorComCentavos.slice(-2);
      return `${parseInt(reais, 10)},${centavos}`;
    };
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      setAlertModal(null);
      const valorDigitado = e.target.value.replace(/\D/g, '');
      const valorFormatado = formatarValorMonetario(valorDigitado);
      setValorRM(valorFormatado);
    };
    return (
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton onHide={props.onHide}>
          <Modal.Title id="contained-modal-title-vcenter">
            Informe Valor de Margem
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alertModal && <div className={`alert alert-${alertModal.type}`}>{alertModal.message}</div>}
          <Form.Label>{isEmprestimo ? 'Valor Margem' : 'Valor RMC'}</Form.Label>
          <input required id="Campo-obrigatorio" type="text" className="form-control" value={valorRM} onChange={handleChange} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => handleButtonClick()}>OK!</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const [modalBoletoShow, setModalBoletoShow] = useState(false);

  interface BoletoPixModalProps {
    show: boolean;
    onHide: () => void;
    // Adicione esta linha:
    dadosBancariosPadrao?: {
      tipoConta?: string;
      codigoBanco?: string;
      agencia?: string;
      dvAgencia?: string;
      conta?: string;
      dvConta?: string;
    };
    // Atualize o onConfirm para suportar os novos campos
    onConfirm: (dados: {
      arquivo: string;
      nomeArquivo: string;
      tipo: string;
      codigo: string | null;
      dadosBancarios?: DadosBancarios | null;
    }) => void;
  }

  const BoletoPixModal: React.FC<BoletoPixModalProps> = (props) => {
    const [arquivo, setArquivo] = useState<File | null>(null);
    const [tpPagamento, setTpPagamento] = useState("1");
    const [codigoDigitado, setCodigoDigitado] = useState('');
    const [alertModal, setAlertModal] = useState<{ message: string, type: 'danger' | 'warning' } | null>(null);

    // Estados para TED
    const [usarDadosCadastrados, setUsarDadosCadastrados] = useState(false);
    const [tipoConta, setTipoConta] = useState("");
    const [codigoBanco, setCodigoBanco] = useState("");
    const [agencia, setAgencia] = useState("");
    const [dvAgencia, setDvAgencia] = useState("");
    const [conta, setConta] = useState("");
    const [dvConta, setDvConta] = useState("");

    const handleCheckboxDadosBancarios = (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.target.checked;
      setUsarDadosCadastrados(checked);

      if (checked && props.dadosBancariosPadrao) {
        setTipoConta(props.dadosBancariosPadrao.tipoConta || "");
        setCodigoBanco(props.dadosBancariosPadrao.codigoBanco || "");
        setAgencia(props.dadosBancariosPadrao.agencia || "");
        setDvAgencia(props.dadosBancariosPadrao.dvAgencia || "");
        setConta(props.dadosBancariosPadrao.conta || "");
        setDvConta(props.dadosBancariosPadrao.dvConta || "");
      }
    };

    // Lógica de validação baseada no que discutimos
    const validarEntrada = () => {

      if (!arquivo) return "Por favor, anexe o arquivo do boleto.";
      if (tpPagamento === "4") { // Validação específica para TED
        if (!agencia || !conta) return "Agência e Conta são obrigatórios para TED.";
      } else {
        const valor = codigoDigitado.trim();
        const valorMinusculo = valor.toLowerCase();
        const apenasNumeros = valor.replace(/\D/g, '');

        if (!valor) return "Por favor, insira o código de pagamento.";

        switch (tpPagamento) {
          case "1": // Linha Digitável
            if (apenasNumeros.length !== 47 && apenasNumeros.length !== 48) {
              return "Linha digitável deve ter 47 ou 48 dígitos.";
            }
            break;
          case "2": // QR Code PIX
            if (!valorMinusculo.startsWith("000201") || !valorMinusculo.includes("br.gov.bcb.pix")) {
              return "O código informado não parece um Pix Copia e Cola válido.";
            }
            break;
          case "3": // Chave Aleatória
            const regexAleatoria = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            if (!regexAleatoria.test(valor)) {
              return "Formato de chave aleatória inválido (ex: 8-4-4-4-12 caracteres).";
            }
            break;
        }

        // Bloqueio extra para evitar CPF/Email/Celular em qualquer campo
        if (tpPagamento !== "1" && (/\S+@\S+\.\S+/.test(valor) || (apenasNumeros.length >= 10 && apenasNumeros.length <= 11))) {
          return "E-mail, CPF ou Celular não são permitidos. Use apenas Chave Aleatória ou Copia e Cola.";
        }
      }
      return null;

    };

    const fileToBase64 = (file: File): Promise<string> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const result = reader.result as string;
          // Remove o prefixo (ex: data:image/png;base64,) para enviar apenas os bytes
          resolve(result.split(',')[1]);
        };
        reader.onerror = (error) => reject(error);
      });
    };

    const handleConfirmar = async () => {
      const erro = validarEntrada();
      if (erro) {
        setAlertModal({ message: erro, type: 'danger' });
        return;
      }

      try {
        // Converte o arquivo para Base64 antes de enviar
        const base64Content = await fileToBase64(arquivo!);

        // Monta o objeto de retorno dependendo do tipo
        const dadosRetorno = {
          arquivo: base64Content,
          nomeArquivo: arquivo!.name,
          tipo: tpPagamento,
          codigo: tpPagamento === "4" ? null : codigoDigitado,
          dadosBancarios: tpPagamento === "4" ? {
            tipoConta, codigoBanco, agencia, dvAgencia, conta, dvConta
          } : null
        };

        props.onConfirm(dadosRetorno);

        // Limpa os estados internos antes de fechar
        setArquivo(null);
        setCodigoDigitado('');
        props.onHide();
      } catch (err) {
        setAlertModal({ message: "Erro ao processar arquivo.", type: 'danger' });
      }
    };
    const tiposConta = [
      { value: 'CC Individual', label: 'CC Individual' },
      { value: 'CP Individual', label: 'CP Individual' },
      { value: 'Conta Salário', label: 'Conta Salário' },
      { value: 'Conta Conjunta', label: 'Conta Conjunta' },
      { value: 'CP Conjunta', label: 'CP Conjunta' },
      { value: 'Conta Investimento', label: 'Conta Investimento' },
    ];

    return (
      <Modal {...props} size="lg" centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Anexar Boleto / PIX</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {alertModal && <div className={`alert alert-${alertModal.type}`}>{alertModal.message}</div>}
          <Form.Group className="mb-3">
            <Form.Label>Arquivo do Boleto (PDF/Imagem)</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf,image/*"
              onChange={(e: any) => setArquivo(e.target.files[0])}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tipo de Pagamento</Form.Label>
            <select
              className="form-select"
              value={tpPagamento}
              onChange={(e) => {
                setTpPagamento(e.target.value);
                setAlertModal(null);
              }}
            >
              {TipoPagamentoEnum.map(item => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>
          </Form.Group>

          {tpPagamento === "4" ? (
            <div className="border p-3 rounded bg-light">
              <Form.Check
                type="switch"
                label="Utilizar informações já cadastradas para o banco"
                className="mb-3"
                checked={usarDadosCadastrados}
                onChange={handleCheckboxDadosBancarios}
              />
              <div className="row g-2">
                <div className="col-md-3">
                  <label className="form-label small">Tipo de Conta</label>
                  <select className="form-select form-select-sm" value={tipoConta} disabled={usarDadosCadastrados} onChange={(e) => setTipoConta(e.target.value)}>
                    <option value=""></option>
                    {tiposConta.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                  </select>
                </div>
                <div className="col-md-1">
                  <label className="form-label small">Banco</label>
                  <InputMask mask="999" maskChar={null} className="form-control form-control-sm" value={codigoBanco} disabled={usarDadosCadastrados} onChange={(e) => setCodigoBanco(e.target.value)} />
                </div>
                <div className="col-md-2">
                  <label className="form-label small">Agência</label>
                  <input type="text" className="form-control form-control-sm" value={agencia} disabled={usarDadosCadastrados} onChange={(e) => setAgencia(e.target.value)} />
                </div>
                <div className="col-md-2">
                  <label className="form-label small">DV Agência</label>
                  <InputMask mask="9" maskChar={null} className="form-control form-control-sm" value={dvAgencia} disabled={usarDadosCadastrados} onChange={(e) => setDvAgencia(e.target.value)} />
                </div>
                <div className="col-md-2">
                  <label className="form-label small">Conta</label>
                  <input type="text" className="form-control form-control-sm" value={conta} disabled={usarDadosCadastrados} onChange={(e) => setConta(e.target.value)} />
                </div>
                <div className="col-md-2">
                  <label className="form-label small">DV Conta</label>
                  <InputMask mask="9" maskChar={null} className="form-control form-control-sm" value={dvConta} disabled={usarDadosCadastrados} onChange={(e) => setDvConta(e.target.value)} />
                </div>
              </div>
            </div>
          ) : (
            <Form.Group className="mb-3">
              <Form.Label>Código / Chave</Form.Label>
              <Form.Control as="textarea" rows={3} value={codigoDigitado} onChange={(e) => setCodigoDigitado(e.target.value)} />
              <Form.Text className="text-muted">
                {tpPagamento === "3" && "Atenção: Apenas chaves aleatórias são aceitas."}
              </Form.Text>
            </Form.Group>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>Cancelar</Button>
          <Button variant="success" onClick={handleConfirmar}>Confirmar Inclusão</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const handleSalvarDadosPagamento = (dados: { arquivo: string, nomeArquivo: string, tipo: string, codigo: string | null, dadosBancarios?: any }) => {
    setSaldoDivida(prevState => ({
      ...prevState,
      arquivo: dados.arquivo,
      nomeArquivo: dados.nomeArquivo,
      tipoPagamento: dados.tipo,
      informacaoPagamento: dados.codigo || '',
      selecionado: true,
      tipoConta: dados.dadosBancarios?.tipoConta || '',
      codigoBanco: dados.dadosBancarios?.codigoBanco || '',
      agencia: dados.dadosBancarios?.agencia || '',
      dvAgencia: dados.dadosBancarios?.dvAgencia || '',
      conta: dados.dadosBancarios?.conta || '',
      dvConta: dados.dadosBancarios?.dvConta || ''
    }));
  };

  const handleModalBoletoShow = () => {
    const { dataVencimento } = saldoDivida;

    if (!(dataVencimento instanceof Date) || isNaN(dataVencimento.getTime())) {
      setAlert({ message: 'Informe uma data de vencimento válida antes de importar o arquivo.', type: 'warning' });
      return;
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const vencimentoNormalizado = new Date(dataVencimento);
    vencimentoNormalizado.setHours(0, 0, 0, 0);

    if (vencimentoNormalizado <= hoje) {
      setAlert({ message: 'Saldo Devedor Vencido. Não é possível seguir com a operação.', type: 'warning' });
      return;
    }

    setModalBoletoShow(true);
  };

  const verificaMargemOnline = () => {
    if (valorRMCOnline !== '' && parseFloat(valorRMCOnline.replace(',', '.')) < 0) {
      setAlert({ message: 'Margem Online negativa.', type: 'error' });
      return;
    }
    setMostrarSaldoDevedor(true);
  }

  const listarPontoVendas = async (id: any) => {
    setLoading(true);
    try {
      await pontoVendaService.listarPontoVendaPorPromotora(id)
        .then(resp => {
          const ativos = (resp.data as PontoVendaDTO[]).filter(item => item.ativo);
          setPontoVendas(ativos);
          setPontoVenda(ativos[0]?.id?.toString() ?? "");
          esconderCampos();
          setLoading(false);
        })
    } catch (err) {
      setLoading(false);
      setPontoVenda('');
      setEmpregador('');
      setOrgao('');
      console.error(err);
    }
  }

  const listarEmpregadorPorPromotora = async (id: any) => {
    try {
      setLoading(true);
      await promotoraEmpregadorService.listarEmpregadorPorPromotora(id)
        .then(resp => {
          const jsonListPromotoraEmpregador = resp.data;
          console.log(resp.data)
          setPromotoraEmpregador(resp.data ?? []);
          if (!jsonListPromotoraEmpregador?.length) {
            setEmpregador('');
            setOrgao('');
            setIsEmpregadorMargemOnline(false);
            setIsMatriculaObrigatoria(false);
            setIsCodigoAutorizacaoObrigatorio(false);
            esconderCampos();
            setLoading(false);
            return;
          }
          setEmpregador(jsonListPromotoraEmpregador[0].id?.toString()!);
          setCodigoMotor(jsonListPromotoraEmpregador[0].codigoMotor!);
          setIsEmpregadorMargemOnline(jsonListPromotoraEmpregador[0].consultaMargem!);
          setIsMatriculaObrigatoria(jsonListPromotoraEmpregador[0].matriculaObrigatoria!);
          setIsCodigoAutorizacaoObrigatorio(jsonListPromotoraEmpregador[0].codigoAutorizacaoObrigatorio!);
          listarOrgaoPorEmpregador(jsonListPromotoraEmpregador[0].id?.toString()!);
          esconderCampos();
          setLoading(false);
        })
    } catch (err) {
      setLoading(false);
      setEmpregador('');
      setIsEmpregadorMargemOnline(false);
      setIsMatriculaObrigatoria(false);
      setIsCodigoAutorizacaoObrigatorio(false);
      setOrgao('');
      console.error(err);
    }
  }


  const propostasDisponiveis = useMemo(() => {
    if (!tpProduto) return [];

    const permitidas = PROPOSTAS_POR_PRODUTO[tpProduto] || [];

    return TiposProposta.filter(p =>
      permitidas.includes(p.value)
    );
  }, [tpProduto]);


  const listarOrgaoPorEmpregador = async (id: any) => {
    try {
      setLoading(true);
      await empregadorService.listarOrgaoPorEmpregador(id)
        .then(resp => {
          const jsonListOrgao = resp.data;

          setOrgaos(jsonListOrgao);
          setOrgao(jsonListOrgao[0].id?.toString()!);
          esconderCampos();
          setLoading(false);
        })
    } catch (err) {
      setLoading(false);
      setOrgao('');
      console.error(err);
    }
  }

  const handleEmpregadorChange = (e: any) => {
    setEmpregador(e.target.value);
    const selectedEmpregador = promotoraEmpregador.find(item => parseInt(item.id!) === parseInt(e.target.value));
    if (selectedEmpregador) {
      setCodigoMotor(selectedEmpregador.codigoMotor);
      setIsEmpregadorMargemOnline(selectedEmpregador.consultaMargem!);
      setIsMatriculaObrigatoria(selectedEmpregador.matriculaObrigatoria!);
      setIsCodigoAutorizacaoObrigatorio(selectedEmpregador.codigoAutorizacaoObrigatorio!);
    }
    esconderCampos();
    listarOrgaoPorEmpregador(e.target.value);
  };

  const carregarTabelaFinanciamentos = async () => {
    setIdFinanciamentoEscolhido('');
    setFinanciamento('');
    if (valorRMC === '') return setAlert({ message: 'Preencha o Valor RMC', type: 'warning' });
    if (valorRMCOnline !== '' && valorRMC > valorRMCOnline) {
      setAlert({ message: 'Valor RMC alterado para maior que o valor RMC Online', type: 'warning' });
      return;
    } else if (dtNascimento === '' || dtNascimento.length < 10) {
      setAlert({ message: 'Preencha Data de Nascimento', type: 'warning' });
    } else {
      try {
        setLoading(true);

        await financiamentoService.listarFinanciamentoPorPromotoraEmpregadorProposta(promotora, empregador, tpProposta, tpProduto, cpf)
          .then(resp => {
            const jsonListFinanciamento = resp.data;
            console.log(jsonListFinanciamento)
            setTabelaFinanciamentos(jsonListFinanciamento);
            setLoading(false);
          })
      } catch (err: any) {
        setLoading(false);
        // Exibe a mensagem de erro retornada pelo backend (incluindo o erro de proposta em andamento)
        setAlert({ message: err.response.data, type: 'warning' });
      }
    }
  }

  const esconderCampos = () => {
    setValorRMC('');
    setRmcDisponivel(false);
    setTabelaFinanciamentos([]);
    setIdFinanciamentoEscolhido('');
    setShowResultadoSimulacao(false);
    setFinanciamento('');
    handleValorParcela('0');
    handleValorSolicitado('0');
  }



  const informarMargemManual = async () => {

    if (promotora && pontoVenda && empregador && orgao && cpf && isNomeValido(nome) && dtNascimento && tpProposta !== '' &&

      (!isMatriculaObrigatoria || (isMatriculaObrigatoria && matricula !== '')) &&
      (!isCodigoAutorizacaoObrigatorio || (isCodigoAutorizacaoObrigatorio && codigoAutorizacao !== ''))
    ) {
      if (!cpfValidacao.isValid(cpf)) {
        setAlert({ message: 'CPF Inválido', type: 'warning' });
        return;
      }
      setModalShow(true);
    } else {
      if (!tpProposta) {
        setAlert({ message: 'Selecione o Tipo de Proposta.', type: 'warning' });
      } else if (!isNomeValido(nome) && nome !== "") {
        setAlert({ message: 'O nome inserido é inválido ou contém caracteres proibidos.', type: 'warning' });
      } else {
        setAlert({ message: 'Preencha todos os campos obrigatórios corretamente.', type: 'warning' });
      }
    }
  }

  const obterMargemOnline = async () => {
    if (promotora && pontoVenda && empregador && orgao && cpf && nome && dtNascimento &&
      (!isMatriculaObrigatoria || (isMatriculaObrigatoria && matricula !== '')) &&
      (!isCodigoAutorizacaoObrigatorio || (isCodigoAutorizacaoObrigatorio && codigoAutorizacao !== ''))
    ) {
      if (!cpfValidacao.isValid(cpf)) {
        setAlert({ message: 'CPF Inválido', type: 'warning' });
        return;
      }
      let cliente: Cliente = new Cliente();

      cliente.cpf = cpf;
      cliente.matricula = matricula === '' ? 0 + '' : matricula;
      cliente.codigoAutorizacao = codigoAutorizacao;
      cliente.nome = nome;

      setLoading(true);
      try {
        await propostaService.obterMargemOnline(codigoMotor, empregador, promotora, pontoVenda, cliente, tpProduto)
          .then(resp => {
            const json = resp.data;
            setRmcDisponivel(true);
            setValorRMC(parseFloat(json.valorMargem).toFixed(2).replace('.', ','));
            setValorRMCOnline(parseFloat(json.valorMargem).toFixed(2).replace('.', ','));
            setLotacao(json.lotacao);
            setNome(limparNome(json.nome));
            setMatricula(json.matricula);
            setSecretaria(json.secretaria);
            if (json.secretaria) {
              const orgaoEncontrado = orgaos.find(item => item.nome.includes(json.secretaria));
              // setOrgao(orgaoEncontrado?.id?.toString() || "");
            }
            setSituacao(json.situacao);
            setLoading(false);
          })

      } catch (err: any) {
        setLoading(false);
        console.log(err.message);
        setAlert({ message: err.response ? err.response.data : "Motor de consulta excedeu o tempo de resposta. Tente novamente mais tarde.", type: 'error' });
      }

    } else {
      setAlert({ message: 'Preencha os campos obrigatórios', type: 'warning' });
    }
  }

  const handleInputChange = (event: any) => {
    setTabelaFinanciamentos([]);
    const inputValue = event.target.value;
    const cleanValue = inputValue.replace(/[,.]/g, '');
    const formattedValue = cleanValue.replace(/(\d+)(\d{2})$/, '$1,$2');
    setValorRMC(formattedValue);
  };

  const buscarValoresTabela = async (codigoFinanciamento: string) => {
    try {
      setShowResultadoSimulacao(false);
      setLoading(true);
      let calculoResultadoSimulacaoDTO: CalculoResultadoSimulacaoDTO = new CalculoResultadoSimulacaoDTO();
      if (tpProposta === 'SAQUE_REFIN' || tpProposta === 'SAQUE_REFIN_EXT') {
        calculoResultadoSimulacaoDTO.valoresRMCRefin = contratosRefinList.filter(item => item.selecionadoRefin).reduce((soma, item) => soma + item.rmcUtilizado, 0);
      } else if (tpProposta === 'COMPRA_DIVIDA_SAQUE') {
        calculoResultadoSimulacaoDTO.valoresRMCCompraDivida = listaSaldoDivida.filter(item => item.selecionado).reduce((soma, item) => soma + parseFloat(item.valorParcela.replace(',', '.')), 0);
      } else {
        calculoResultadoSimulacaoDTO.valoresRMCRefin = null;
        calculoResultadoSimulacaoDTO.valoresRMCCompraDivida = null;
      }
      calculoResultadoSimulacaoDTO.promotora = promotora;
      calculoResultadoSimulacaoDTO.empregador = empregador;
      calculoResultadoSimulacaoDTO.financiamento = codigoFinanciamento;
      calculoResultadoSimulacaoDTO.produto = tabelaFinanciamentos.find(item => item.codigo === codigoFinanciamento)?.idProduto!;
      calculoResultadoSimulacaoDTO.valorRMC = parseFloat(valorRMC !== '' ? valorRMC.replace(',', '.') : '0');
      calculoResultadoSimulacaoDTO.valorLimite = 0;
      calculoResultadoSimulacaoDTO.limiteCompra = 0;
      calculoResultadoSimulacaoDTO.limiteSaque = 0;
      calculoResultadoSimulacaoDTO.tarifaEmissao = 0;
      calculoResultadoSimulacaoDTO.anuidade = 0;
      calculoResultadoSimulacaoDTO.dtNascimentoCliente = parse(dtNascimento, "dd/MM/yyyy", new Date());

      console.log(calculoResultadoSimulacaoDTO);
      await propostaService.simulacaoRMCTotal(calculoResultadoSimulacaoDTO)
        .then(resp => {
          const jsonList = resp.data;

          setValoresSimulacao(jsonList);
          handleValorParcela(!isEmprestimo ? jsonList.limiteSaque!.toFixed(2).replace('.', ',') : jsonList.valorRMC!.toFixed(2).replace('.', ','));
          setPrazos(jsonList.prazos);
          setPrazo(jsonList.prazos[0]);
          setLoading(false);
        })
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
      setIdFinanciamentoEscolhido('');
      setFinanciamento('')
    }
    scrowDown();
  }

  const resultadoSimulacaoParcela = async (e: any) => {
    const valorSolicitadoNumerico = parseFloat(valorSolicitado.replace(',', '.'));
    const limiteDaPolitica = valoresSimulacao?.valorMaximoLimiteCompra || 0;
    if (limiteDaPolitica > 0 && valorSolicitadoNumerico > limiteDaPolitica) {
      setAlert({
        message: `O Valor Solicitado (R$ ${valorSolicitado}) não pode ser maior que o Valor Máximo de Limite da política (R$ ${limiteDaPolitica.toFixed(2).replace('.', ',')}).`,
        type: 'warning'
      });
      return;
    }
    e.preventDefault();
    if ((parseFloat(valorParcela) !== 0 && parseFloat(valorSolicitado) !== 0)) {
      setAlert({ message: 'Informe apenas ou valor da parcela ou valor solicitado!', type: 'warning' });
      return;
    } else if ((valorParcela === null && valorSolicitado === null) || (parseFloat(valorParcela) === 0 && parseFloat(valorSolicitado) === 0)) {
      setAlert({ message: 'Informe valor da parcela ou valor solicitado!', type: 'warning' });
      return;
    } else if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && isCompraDivida) {
      setAlert({ message: 'Informe valor da parcela menor ou igual à soma das parcelas + limite de saque', type: 'warning' });
    } else if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && !isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    } else if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.valorRMC.toFixed(2)!) && isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    } else {
      if ((tpProposta === 'SAQUE_REFIN' || tpProposta === 'SAQUE_REFIN_EXT') && !contratosRefinList.some(item => item.selecionadoRefin)) {
        setAlert({ message: 'Selecione pelo menos um Contrato para refinanciar!', type: 'warning' });
        return;
      }
      if (tpProposta === 'COMPRA_DIVIDA_SAQUE' && !listaSaldoDivida.some(item => item.selecionado)) {
        setAlert({ message: 'Selecione pelo menos um Contrato para Compra de Dívida!', type: 'warning' });
        return;
      }
      let simulacaoPropostaDTO: ResultadoSimulacaoPropostaDTO = new ResultadoSimulacaoPropostaDTO();
      simulacaoPropostaDTO.promotora = promotora;
      simulacaoPropostaDTO.pontoVenda = pontoVenda;
      simulacaoPropostaDTO.empregador = empregador;
      simulacaoPropostaDTO.financiamento = idFinanciamentoEscolhido;
      simulacaoPropostaDTO.produto = tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.idProduto!;
      simulacaoPropostaDTO.tipoProposta = tpProposta;
      simulacaoPropostaDTO.valorRMC = parseFloat(valorRMC.replace(',', '.'));
      simulacaoPropostaDTO.valorParcela = parseFloat(valorParcela.replace(',', '.'));
      simulacaoPropostaDTO.valorSolicitado = parseFloat(valorSolicitado.replace(',', '.'));
      simulacaoPropostaDTO.prazo = parseInt(prazo);
      simulacaoPropostaDTO.contratosRefin = contratosRefinList.filter(item => item.selecionadoRefin).map(item => item);
      
      // Format dataVencimento to yyyy-MM-dd for Java LocalDate compatibility
      simulacaoPropostaDTO.contratosCompra = listaSaldoDivida.filter(item => item.selecionado).map(item => ({
        ...item,
        dataVencimento: item.dataVencimento instanceof Date 
          ? format(item.dataVencimento, 'yyyy-MM-dd') 
          : item.dataVencimento
      })) as any;

      simulacaoPropostaDTO.limiteSaque = valoresSimulacao?.limiteSaque!;

      simulacaoPropostaDTO.cpfCliente = cpf;
      simulacaoPropostaDTO.nomeCliente = nome;
      simulacaoPropostaDTO.matriculaCliente = matricula;
      simulacaoPropostaDTO.dtNascimentoCliente = parse(dtNascimento, "dd/MM/yyyy", new Date());
      simulacaoPropostaDTO.orgao = orgao
      simulacaoPropostaDTO.valorIof = 0;
      simulacaoPropostaDTO.valorPrincipal = 0;
      simulacaoPropostaDTO.valorRefin = 0;
      simulacaoPropostaDTO.valorCompra = 0;
      simulacaoPropostaDTO.valorLiquido = 0;
      simulacaoPropostaDTO.valorBruto = 0;
      simulacaoPropostaDTO.taxaClAM = 0;
      simulacaoPropostaDTO.taxaClAA = 0;
      simulacaoPropostaDTO.taxaCetAM = 0;
      simulacaoPropostaDTO.taxaCetAA = 0;
      simulacaoPropostaDTO.primeiroVencimento = new Date();
      simulacaoPropostaDTO.ultimoVencimento = new Date();

      try {
        setLoading(true);
        console.log(simulacaoPropostaDTO);
        await propostaService.resultadoSimulacaoParcela(simulacaoPropostaDTO)
          .then(resp => {
            const jsonList = resp.data;
            console.log(resp.data)

            setResultadoSimulacaoFinal(jsonList);
            setDtPrimeiroVencimento(format(parseISO(jsonList.primeiroVencimento), 'dd/MM/yyyy'));
            setDtUltimoVencimento(format(parseISO(jsonList.ultimoVencimento), 'dd/MM/yyyy'));
            setShowResultadoSimulacao(true);
            setLoading(false);
          })
      } catch (err: any) {
        setLoading(false);
        console.error(err);
        setAlert({ message: err.response.data, type: 'error' });
        setShowResultadoSimulacao(false);

      }
    }
    scrowDown();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let propostaDTO: PropostaDTO = new PropostaDTO();
    let cliente: Cliente = new Cliente();

    cliente.cpf = cpf;
    const partesData = dtNascimento.split('/');
    const dataFormatada = partesData[2] + '-' + partesData[1] + '-' + partesData[0];
    const novaData = new Date(dataFormatada);
    cliente.dtNascimento = new Date(novaData);
    cliente.nome = nome;
    cliente.matricula = matricula;
    cliente.codigoAutorizacao = codigoAutorizacao;
    cliente.situacaoServidor = situacao;

    propostaDTO.promotora = promotora;
    propostaDTO.pontoVenda = pontoVenda;

    if (origemSelecionada && origemSelecionada !== '0') {
      const [tipo, id] = origemSelecionada.split('_');
      if (tipo === 'CONSIGNATARIA') {
        propostaDTO.idOriginador = Number(id);
      } else {
        propostaDTO.idOriginador = undefined as any; 
      }
    }    propostaDTO.produto = tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.idProduto!;
    
    propostaDTO.tipoProposta = tpProposta;
    propostaDTO.empregador = empregador;
    propostaDTO.orgao = orgao;
    propostaDTO.cliente = cliente;
    propostaDTO.valorRMCUtilizado = parseFloat(valorRMC);
    propostaDTO.valorLimite = valoresSimulacao?.valorLimite!;
    propostaDTO.limiteCompra = valoresSimulacao?.limiteCompra!;
    propostaDTO.limiteSaque = valoresSimulacao?.limiteSaque!;
    propostaDTO.tarifaEmissao = valoresSimulacao?.tarifaEmissao!;
    propostaDTO.anuidade = valoresSimulacao?.anuidade!;
    propostaDTO.financiamento = financiamento;
    propostaDTO.valorMargemOnline = parseFloat(valorRMCOnline.replace(',', '.'));

    propostaDTO.simulacaoProposta = resultadoSimulacaoFinal!;

    if (tpProposta === 'SAQUE_REFIN_EXT') {
      propostaDTO.simulacaoProposta.contratosRefin = contratosRefinList.filter(item => item.selecionadoRefin).map(item => item);
    }
    try {
      setLoading(true);
      await propostaService.inclusaoProposta(propostaDTO)
        .then(resp => {
          const json = resp.data;

          setLoading(false);
          setAlert({ message: 'Inclusão realizada com sucesso!', type: 'success' });
          sleep(2000);
          navigate('/esteira-cliente/alteracao', { state: { idCliente: json.idCliente, edicao: 'proposta', idProposta: json.id, atualizacaoCadastro: 'false' } });
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
      setAlert({ message: 'Ocorreu um erro ao cadastrar proposta!', type: 'error' });
    }
  };

  const buscaClientePorCpfEMatricula = async (cpf: string) => {
    if (cpf.length !== 14) return;
    try {
      setLoading(true);
      await clienteService.buscarClientePorCpf(cpf)
        .then(resp => {
          const json = resp.data;
          if (json) {
            setNome(limparNome(json.nome));
            setMatricula(json.matricula);
            setDtNascimento(formatDate(json.dtNascimento));
          } else {
            setNome('');
            setMatricula('');
            setDtNascimento('');
          }
        })
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "";

    const dateParts = dateString.split(" ")[0].split("-");
    const year = dateParts[0];
    const month = dateParts[1];
    const day = dateParts[2].split("T")[0];
    return `${day}/${month}/${year}`;
  };

  const listarContratosRefin = async () => {
    if (tpProposta !== 'SAQUE_REFIN' && tpProposta !== 'SAQUE_REFIN_EXT') return;
    try {
      setLoading(true);
      await operacaoParcelaService.listarOperacoesRefinPorCpfMatriculaEmpregador(cpf, matricula, empregador)
        .then(resp => {
          const json = resp.data;
          setContratosRefinList(json);
        })
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
    scrowDown();
  };

  const handleEscolhaTabelaFinanciamento = (item: any) => {
    setIdFinanciamentoEscolhido(item.codigo);
    buscarValoresTabela(item.codigo);
    setFinanciamento(item.id != null ? item.id.toString() : '');
    listarContratosRefin();
  }

  const formatarValorMonetario = (valor: any) => {
    if (!valor) return '0,00';
    const valorComCentavos = valor.padStart(3, '0');
    const reais = valorComCentavos.slice(0, -2);
    const centavos = valorComCentavos.slice(-2);
    return `${parseInt(reais, 10)},${centavos}`;
  };

  const handleValorParcela = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorParcela(valorFormatado);
  };

  const handleValorSolicitado = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorSolicitado(valorFormatado);
  };

  const handleSelectionChangeCompraDivida = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newList = [...listaSaldoDivida];
    newList[index].selecionado = e.target.checked;
    setListaSaldoDivida(newList);
  }

  const handleSelectionChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newList = [...contratosRefinList];
    newList[index].selecionadoRefin = e.target.checked;
    setContratosRefinList(newList);
  };

  // useEffect(() => {
  // //   listarOriginador();
  // //   listarTodosBancos();
  // // }, []);

  useEffect(() => {
    if (!promotora) return;

    listarPontoVendas(promotora);
    listarEmpregadorPorPromotora(promotora);
    listarOrgaoPorEmpregador(promotora);

    esconderCampos();
  }, [promotora]);

  useEffect(() => {
    if (
      tpProposta &&
      !propostasDisponiveis.find(p => p.value === tpProposta)
    ) {
      setTpProposta('');
    }

  }, [propostasDisponiveis, tpProposta]);

  useEffect(() => {
    if (!tpProduto && tiposProduto.length > 0) {
      setTpProduto(tiposProduto[0].value);
    }
  }, [tiposProduto, tpProduto]);

  useEffect(() => {
    setMostrarSaldoDevedor(false);
    setPossuiSaldoDevedor(false);
    setListaSaldoDivida([]);
  }, [tpProposta]);

  const removerSaldoDivida = (index: number) => {
    const novaLista = listaSaldoDivida.filter((_, i) => i !== index);
    setListaSaldoDivida(novaLista);

    if (novaLista.length === 0) {
      setPossuiSaldoDevedor(false);
    }
  };

  const handleAdicionarSaldoDivida = () => {
    const { dataVencimento } = saldoDivida;

    if (saldoDivida.bancoEntidade === '' || saldoDivida.numeroContrato === '' || saldoDivida.saldoDevedor === '' ||
      // saldoDivida.prazo === 0 || 
      saldoDivida.valorParcela === '' || saldoDivida.arquivo === null) {
      setAlert({ message: 'Preencha os campos obrigatórios.', type: 'warning' });
      return;
    }

    if (!(dataVencimento instanceof Date) || isNaN(dataVencimento.getTime())) {
      setAlert({ message: 'Informe uma data de vencimento válida.', type: 'warning' });
      return;
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const vencimentoNormalizado = new Date(dataVencimento);
    vencimentoNormalizado.setHours(0, 0, 0, 0);

    if (vencimentoNormalizado <= hoje) {
      setAlert({ message: 'Saldo Devedor Vencido. Não é possível seguir com a operação.', type: 'warning' });
      return;
    }

    // if (saldoDivida.prazo <= saldoDivida.parcelasPagas) {
    //   setAlert({ message: 'O campo Prazo deve ser maior que o número de parcelas pagas.', type: 'warning' });
    //   return;
    // }

    adicionarSaldoDivida();
  };

  const adicionarSaldoDivida = () => {
    setListaSaldoDivida((prev) => [...prev, saldoDivida]);

    setSaldoDivida({
      bancoEntidade: '',
      numeroContrato: '',
      saldoDevedor: '',
      prazo: 0,
      parcelasPagas: 0,
      valorParcela: '',
      arquivo: null,
      nomeArquivo: '',
      tipoPagamento: '',
      informacaoPagamento: '',
      selecionado: false,
      tipoConta: '',
      codigoBanco: '',
      agencia: '',
      dvAgencia: '',
      conta: '',
      dvConta: '',
      dataVencimento: addDays(new Date(), 1)
    });

    setPossuiSaldoDevedor(true);
  };

  const handleEditarSaldoDivida = (index: number) => {
    const saldo = listaSaldoDivida[index];
    setSaldoDivida(saldo);
    removerSaldoDivida(index);
  };

  const listarTodosBancos = async () => {
    try {
      setLoading(true);
      const responseList = await bancoService.listarTodosBancos();
      setBancos(responseList.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleChangeValorSaldoDivida = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: 'saldoDevedor' | 'valorParcela'
  ) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);

    setSaldoDivida((prev) => ({
      ...prev,
      [field]: valorFormatado,
    }));
  };


  const getLabelMargemDisponivel = (tpProduto: string) => {
    return tpProduto === 'EMPRESTIMO' || tpProduto === 'ANTECIPACAO_REMUNERACAO'
      ? 'Margem disponível'
      : 'RMC disponível';
  };

  const getLabelDadosRefinCompra = (tpProposta: string) => {
    return tpProposta === 'SAQUE_REFIN' || tpProposta === 'SAQUE_REFIN_EXT'
      ? 'Dados do Refinanciamento'
      : 'Dados da Compra de Dívida';
  };

  const downloadBase64 = (base64String: string, fileName: string): void => {
    // Remove o prefixo se ele existir para converter corretamente
    const base64Data = base64String.split(',')[1] || base64String;

    // Converte Base64 para um array de bytes
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Cria o Blob e a URL temporária
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    // Limpeza
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url); // Importante para memória!
  };

  interface ArquivoItem {
    arquivo: string;      // A string Base64
    nomeArquivo: string;  // Ex: "relatorio.pdf"
    caminhoArquivo?: string;
  }


  return (
    <Container>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : false}
      <form onSubmit={handleSubmit} >
        <Row className="mb-3">
          <Form.Group as={Col} md='4' controlId="formBasicSelectOrigem">
            <Form.Label>Origem</Form.Label>
            <select
              className="form-select"
              id="Campo-obrigatorio"
              disabled={origens.length === 0}
              value={origemSelecionada}
              onChange={(e) => { 
                setOrigemSelecionada(e.target.value); 
                setPromotora('0'); 
                setPontoVenda('0'); 
                setPontoVendas([]); 
                esconderCampos();
              }}
            >
              <option value="0">Selecione uma opção</option>
              {origens.map((item: any) => {
                // Previne que o sistema coloque MATRIZ_MATRIZ_1 se o Contexto já trouxer formatado
                const valorFormatado = String(item.id).includes('_') ? item.id : `${item.tipoOrigem}_${item.id}`;
                return (
                  <option key={valorFormatado} value={valorFormatado}>
                    {item.nome}
                  </option>
                );
              })}
            </select>
          </Form.Group>

          <Form.Group as={Col} md='4' controlId="formBasicSelectPromotora">
            <Form.Label>Promotora</Form.Label>
            <select className="form-select" id="Campo-obrigatorio"
              disabled={promotoras.length === 0 || !origemSelecionada || origemSelecionada === '0'}
              value={promotora} 
              onChange={(e) => {
                setPromotora(e.target.value);
                setPontoVenda('0');
                setPontoVendas([]);
                esconderCampos();
              }}
            >
              <option value="0">Selecione uma opção</option>
              {promotoras.map((item) => (
                <option key={item.id} value={item.id!}>
                  {item.id + ' - ' + item.nome}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group as={Col} md='4' controlId="formBasicSelect">
            <Form.Label>Ponto de Venda </Form.Label>
            <select className="form-select" id="Campo-obrigatorio"
              defaultValue={pontoVenda}
              value={pontoVenda}
              disabled={usuarioLogado?.role === 'ROLE_PONTO_VENDA'}
              onChange={(e) => { setPontoVenda(e.target.value); esconderCampos() }}
            >
              {pontoVendas.map((item) => (
                <option key={item.id} value={item.id!}>
                  {item.id + ' - ' + item.nome}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group as={Col} md='4' controlId="formBasicSelect">
            <Form.Label>Tipo de Produto </Form.Label>
            <select
              className="form-select"
              value={tpProduto}
              onChange={(e) => setTpProduto(e.target.value)}
            >
              {TiposProduto.map(item => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>

          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md='4' controlId="formBasicSelect">
            <Form.Label>Tipo de Proposta</Form.Label>
            <select
              className="form-select"
              id="Campo-obrigatorio"
              value={tpProposta}
              onChange={(e) => setTpProposta(e.target.value)}
              disabled={!tpProduto}
            >
              <option value="">Selecione</option>

              {propostasDisponiveis.map(item => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>

          </Form.Group>

          <Form.Group as={Col} md='4' controlId="formBasicSelect">
            <Form.Label>Empregador</Form.Label>
            <select className="form-select" id="Campo-obrigatorio"
              defaultValue={empregador} value={empregador} onChange={(e) => { handleEmpregadorChange(e); esconderCampos() }}
            >
              {promotoraEmpregador.map((item) => (
                <option key={item.id} value={item.id!}>
                  {item.id + ' - ' + item.nome}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group as={Col} md='4' controlId="formBasicSelect">
            <Form.Label>Orgão (Secretaria/UPAG)</Form.Label>
            <select className="form-select" id="Campo-obrigatorio"
              defaultValue={orgao} value={orgao} onChange={(e) => { setOrgao(e.target.value); esconderCampos() }}
            >
              {orgaos.map((item) => (
                <option key={item.id} value={item.id!}>
                  {item.id + ' - ' + item.nome}
                </option>
              ))}
            </select>
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md="3" controlId="validationCpf">
            <Form.Label>CPF</Form.Label>
            <InputMask id="Campo-obrigatorio" required mask="999.999.999-99" type="text" className="form-control" value={cpf} onChange={(e) => { setCpf(e.target.value); esconderCampos(); buscaClientePorCpfEMatricula(e.target.value.replace(/_/g, "")) }} />
          </Form.Group>
          <Form.Group as={Col} md="2" controlId="validationCodigo">
            <Form.Label>Matrícula</Form.Label>
            <input type="text" required className="form-control" id={isMatriculaObrigatoria ? "Campo-obrigatorio" : ""} value={matricula} onChange={handleMatriculaChange} />
          </Form.Group>

          <Form.Group as={Col} md="4" controlId="validationName">
            <Form.Label>Nome</Form.Label>
            <input
              id="Campo-obrigatorio"
              type="text"
              required
              className="form-control"
              value={nome}
              onChange={handleNomeChange}
            />
          </Form.Group>

          <Form.Group as={Col} md="3" controlId="validationDate">
            <Form.Label>Data de Nascimento </Form.Label>
            <DateInput
              id="Campo-obrigatorio"
              className="form-control"
              value={dtNascimento}
              onChange={(e) => {
                setDtNascimento(e.target.value);
                esconderCampos();
              }}
            />
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md="4" controlId="validationName">
            <Form.Label>Código de Autorização</Form.Label>
            <input type="text" className="form-control" id={isCodigoAutorizacaoObrigatorio ? "Campo-obrigatorio" : ""} value={codigoAutorizacao} onChange={(e) => setCodigoAutorizacao(e.target.value)} />
          </Form.Group>
        </Row>

        <div className='button-area'>
          <Button variant="warning" onClick={() => { informarMargemManual() }}>
            <FaRegMoneyBillAlt style={{ marginRight: '3px', marginBottom: '3px' }} /> Informar Margem
          </Button>
          {isEmpregadorMargemOnline && (
            <Button variant='success' onClick={() => { obterMargemOnline() }}>
              <BiDollar style={{ marginRight: '1px', marginBottom: '3px' }} /> Obter Margem Online
            </Button>
          )}
          {isCompraDivida && !possuiSaldoInformado && (
            <Button
              variant="warning"
              onClick={verificaMargemOnline}
            >
              Informar Saldo
            </Button>
          )}
        </div>

        <MyVerticallyCenteredModal show={modalShow} onHide={() => { setModalShow(false); setRmcDisponivel(true) }} onModalClose={setValorRMC} />

        {(rmcDisponivel || valorRMC !== '' && valorRMC !== undefined) ? (
          <div className="row">
            <div className="col-md-5">
              <div className="alert alert-success alert-dismissible">
                <h5><small>    {getLabelMargemDisponivel(tpProduto)}: R$</small>
                  <input className="form-control" value={valorRMC} onChange={handleInputChange} />
                </h5>
                {lotacao || secretaria || situacao ? (
                  <>
                    <h5><small>Lotação: </small>
                      <span><small>{lotacao}</small> </span>
                    </h5><h5><small>Secretária: </small>
                      <span><small>{secretaria}</small> </span>
                    </h5><h5><small>Situação Servidor: </small>
                      <span><small>{situacao}</small> </span>
                    </h5>
                  </>
                ) : false}
              </div>
            </div>
            <div className="col-md-3 text-left">

              {!isCompraDivida && (
                <Button
                  variant="primary"
                  onClick={carregarTabelaFinanciamentos}
                >
                  <RiCalculatorLine /> Exibir Tabelas
                </Button>
              )}

            </div>

          </div>
        ) : false}
        {isCompraDivida && mostrarSaldoDevedor && (
          <div style={{ marginTop: '20px' }}>
            <h6>Saldo Devedor</h6>

            <div className="row">
              <div className="col-md-2">
                <label>Banco/Entidade<span style={{ color: 'red' }}>*</span></label>
                <select
                  className="form-select"
                  value={saldoDivida.bancoEntidade}
                  onChange={(e) =>
                    setSaldoDivida({
                      ...saldoDivida,
                      bancoEntidade: e.target.value,
                    })
                  }
                >
                  <option value="">Selecione o banco</option>

                  {bancos.map((banco) => (
                    <option key={banco.id} value={banco.id!}>
                      {banco.id + ' - ' + banco.nome}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-md-2">
                <label>Número Contrato <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={saldoDivida.numeroContrato}
                  onChange={(e) =>
                    setSaldoDivida({ ...saldoDivida, numeroContrato: e.target.value })
                  }
                />
              </div>

              <div className="col-md-2">
                <label>Saldo Devedor R$ <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={saldoDivida.saldoDevedor}
                  onChange={(e) => handleChangeValorSaldoDivida(e, 'saldoDevedor')}
                />
              </div>

              <div className="col-md-2">
                <label>Dt. Vencimento <span style={{ color: 'red' }}>*</span></label>
                <DateInput
                  className="form-control"
                  value={saldoDivida.dataVencimento instanceof Date ? format(saldoDivida.dataVencimento, 'dd/MM/yyyy') : (saldoDivida.dataVencimento || '')}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val.length === 10) {
                      const parsed = parse(val, 'dd/MM/yyyy', new Date());
                      setSaldoDivida({ ...saldoDivida, dataVencimento: isValid(parsed) ? parsed : val as any });
                    } else {
                      setSaldoDivida({ ...saldoDivida, dataVencimento: val as any });
                    }
                  }}
                />
              </div>

              {/* <div className="col-md-1">
                <label>Prazo <span style={{ color: 'red' }}>*</span></label>
                <InputMask
                  maskChar={null}
                  required
                  mask="999"
                  type="text"
                  className="form-control"
                  value={saldoDivida.prazo}
                  onChange={(e) =>
                    setSaldoDivida({
                      ...saldoDivida,
                      prazo: e.target.value === "" ? "" : Number(e.target.value.replace(/\D/g, '')),
                    })
                  }
                  onBlur={(e) => {
                    if (e.target.value === "") {
                      setSaldoDivida({
                        ...saldoDivida,
                        prazo: 0,
                      });
                    }
                  }}
                />
              </div>

              <div className="col-md-1">
                <label>Pagas <span style={{ color: 'red' }}>*</span></label>
                <InputMask
                  mask="999"
                  maskChar={null}
                  className="form-control"
                  value={saldoDivida.parcelasPagas}
                  onChange={(e) =>
                    setSaldoDivida({
                      ...saldoDivida,
                      parcelasPagas: e.target.value === "" ? "" : Number(e.target.value.replace(/\D/g, '')),
                    })
                  }
                  onBlur={(e) => {
                    if (e.target.value === "") {
                      setSaldoDivida({
                        ...saldoDivida,
                        parcelasPagas: 0,
                      });
                    }
                  }}
                />
              </div> */}

              <div className="col-md-2">
                <label className="text-nowrap">Vlr. Parcela <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={saldoDivida.valorParcela}
                  onChange={(e) => handleChangeValorSaldoDivida(e, 'valorParcela')}
                />
              </div>
              <div className="col-md-3" style={{ marginTop: '24px', marginBottom: '12px' }}>
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant="success"
                      onClick={handleModalBoletoShow} // Agora abre o seu novo Modal
                    >
                      Importar Arquivo
                    </Button>

                    <BoletoPixModal
                      show={modalBoletoShow}
                      onHide={() => setModalBoletoShow(false)}
                      onConfirm={handleSalvarDadosPagamento}
                      dadosBancariosPadrao={{
                        tipoConta: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.tipoConta,
                        codigoBanco: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.numeroBanco,
                        agencia: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.agencia,
                        dvAgencia: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.dvAgencia,
                        conta: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.conta,
                        dvConta: bancos.find(b => String(b.id) === String(saldoDivida.bancoEntidade))?.dvConta
                      }}
                    />

                    <Button variant="primary" onClick={handleAdicionarSaldoDivida}>
                      +
                    </Button>
                  </div>

                  {saldoDivida.arquivo && (
                    <div className="d-flex flex-column" style={{ marginTop: '4px' }}>
                      <small
                        className="text-success text-truncate"
                        style={{ fontSize: '11px', fontWeight: 'bold' }}
                      >
                        Arquivo: {saldoDivida.nomeArquivo}
                      </small>
                      <small className="text-muted" style={{ fontSize: '10px' }}>
                        Tipo: {TipoPagamentoEnum.find(t => t.value === saldoDivida.tipoPagamento)?.label}
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {listaSaldoDivida.length > 0 && (
              <div className="table-responsive mt-3">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Banco/Entidade</th>
                      <th>Número Contrato</th>
                      <th>Saldo Devedor</th>
                      {/* <th>Prazo</th>
                      <th>Pagas</th> */}
                      <th>Vlr. Parcela</th>
                      <th>Arquvio</th>
                      <th>Editar</th>
                      <th>Excluir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaSaldoDivida.map((item, index) => (
                      <tr key={index}>
                        <td>{bancos.find(b => String(b.id) === String(item.bancoEntidade))?.nome || item.bancoEntidade}</td>
                        <td>{item.numeroContrato}</td>
                        <td>R$ {parseFloat(item.saldoDevedor.replace(',', '.')).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        {/* <td>{item.prazo}</td>
                        <td>{item.parcelasPagas}</td> */}
                        <td>R$ {parseFloat(item.valorParcela.replace(',', '.')).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td>
                          <Button onClick={() => downloadBase64(item.arquivo!, item.nomeArquivo!)}>
                            <FontAwesomeIcon icon={faDownload} />
                          </Button>
                        </td>
                        <td>
                          <Button id="App-button-cor-principal" onClick={() => handleEditarSaldoDivida(index)}>
                            <FontAwesomeIcon icon={faPencil} />
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => removerSaldoDivida(index)}
                          >
                            X
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {isCompraDivida && possuiSaldoDevedor && (
          <div>
            <div className="row mt-3">
              <div className="col-md-12">
                <Button
                  variant="primary"
                  onClick={carregarTabelaFinanciamentos}
                >
                  <RiCalculatorLine /> Exibir Tabelas
                </Button>
              </div>
            </div>
          </div>
        )}
        {tabelaFinanciamentos.length > 0 ? (
          <>
            {loading ? <Spinner loading={loading} /> : false}
            <div className="select-tab">
              Selecione a Tabela
              <Table bordered hover>
                <thead>
                  <tr>
                    <th></th>
                    <th>Código</th>
                    <th>Tabela</th>
                  </tr>
                </thead>
                <tbody>
                  {tabelaFinanciamentos.map((item) => (
                    <tr>
                      <td style={{ width: '1rem' }}>
                        <Button onClick={() => { handleEscolhaTabelaFinanciamento(item) }}><FaCheck /></Button>
                      </td>
                      <td>{item.codigo}</td>
                      <td>{item.nome}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            {idFinanciamentoEscolhido !== '' && !loading ? (
              <>
                {((tpProposta === 'SAQUE_REFIN' || tpProposta === 'SAQUE_REFIN_EXT' || tpProposta === 'COMPRA_DIVIDA_SAQUE')) ? (
                  <div className="select-tab">
                    {getLabelDadosRefinCompra(tpProposta)}
                    {((tpProposta === 'COMPRA_DIVIDA_SAQUE' ? listaSaldoDivida.length : contratosRefinList.length) === 0) ?
                      <Table bordered hover>
                        <thead>
                          <tr><td colSpan={8}>Não há contratos disponíveis para este CPF, Matricula e Empregador!</td></tr>
                        </thead>
                      </Table>
                      : (
                        <Table bordered hover>
                          {tpProposta === 'COMPRA_DIVIDA_SAQUE' ? (
                            <>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Contrato</th>
                                  <th>Banco/Entidade</th>
                                  {/* <th>Prazo</th>
                                  <th>Pagas</th> */}
                                  <th>Valor Parcela</th>
                                  <th>Saldo</th>
                                </tr>
                              </thead>
                              <tbody>
                                {listaSaldoDivida.map((item, index) => {
                                  return (
                                    <OverlayTrigger
                                      key={index}
                                      overlay={<></>}
                                    >
                                      <tr key={index} style={{ backgroundColor: 'transparent' }}>
                                        <td style={{ textAlign: "center" }}>
                                          <input type="checkbox" checked={item.selecionado || false} onChange={(e) => { handleSelectionChangeCompraDivida(e, index); buscarValoresTabela(idFinanciamentoEscolhido); }}
                                            disabled={false}
                                          />
                                        </td>
                                        <td>{item.numeroContrato}</td>
                                        <td>{bancos.find(b => String(b.id) === String(item.bancoEntidade))?.nome || item.bancoEntidade}</td>
                                        {/* <td>{item.prazo}</td>
                                        <td>{item.parcelasPagas}</td> */}
                                        <td>
                                          R$ {parseFloat(item.valorParcela.replace(',', '.')).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td>
                                          R$ {parseFloat(item.saldoDevedor.replace(',', '.')).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                      </tr>
                                    </OverlayTrigger>
                                  );
                                })}
                              </tbody>
                            </>
                          ) : (
                            <>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Contrato</th>
                                  <th>Matrícula</th>
                                  <th>Prazo</th>
                                  <th>Vencidas</th>
                                  <th>A Vencer</th>
                                  <th>Pagas</th>
                                  <th>Valor Parcela</th>
                                  <th>Saldo</th>
                                </tr>
                              </thead>
                              <tbody>
                                {contratosRefinList.map((item, index) => {
                                  const temPropostaEsteira = item.propostaEsteira && item.propostaEsteira !== 0;
                                  return (
                                    <OverlayTrigger
                                      key={index}
                                      overlay={temPropostaEsteira ? (
                                        <Tooltip id={`tooltip-${index}`}>
                                          Há proposta de refinanciamento com esse contrato na esteira: {item.propostaEsteira}
                                        </Tooltip>
                                      ) : <></>}
                                    >
                                      <tr key={index} style={{ backgroundColor: temPropostaEsteira ? 'red !important' : 'transparent' }}>
                                        <td style={{ textAlign: "center" }}>
                                          <input type="checkbox" checked={item.selecionadoRefin || false} onChange={(e) => { handleSelectionChange(e, index); buscarValoresTabela(idFinanciamentoEscolhido); }}
                                            disabled={temPropostaEsteira ? true : false}
                                          />
                                        </td>
                                        <td>{item.contrato}</td>
                                        <td>{item.matricula}</td>
                                        <td>{item.prazo}</td>
                                        <td>{item.parcelasVencidas}</td>
                                        <td>{item.prazo - item.parcelasVencidas - item.parcelasPagas}</td>
                                        <td>{item.parcelasPagas}</td>
                                        <td>
                                          R$ {item.valorParcela != null ? item.valorParcela!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00"}
                                        </td>
                                        <td>
                                          R$ {item.saldo != null ? item.saldo!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00"}
                                        </td>
                                      </tr>
                                    </OverlayTrigger>
                                  );
                                })}
                              </tbody>
                            </>)}
                        </Table>
                      )}
                  </div>
                ) : (
                  <>
                    <div className="header-cards">
                      <b>Resultado Simulação - {idFinanciamentoEscolhido}/{tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.nome}</b>
                    </div>
                    <div style={{ backgroundColor: 'white', padding: 'auto' }}>
                      <div className="input-card">
                        <Form.Label>{isEmprestimo ? 'Valor Margem' : 'Valor do Limite'}</Form.Label>
                        <div className="card-text">
                          R$ {valoresSimulacao?.valorRMC.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                      </div>
                    </div>
                    <CardGroup>
                      {/* CARTÃO: Proposta de Limite */}
                      {!isEmprestimo && (
                        <Card style={{ borderRadius: '0px 0px 0px 15px' }}>
                          <Card.Body>
                            <Card.Title>Proposta de Limite</Card.Title>

                            <div className="card-field">Valor RMC</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorRMC.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Limite Total</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorLimite.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Limite de Compras</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.limiteCompra.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Limite Saque</div>
                            <div className="card-text">
                              R$ {(tpProposta === 'CARTAO_SEM_SAQUE'
                                ? 0
                                : valoresSimulacao?.limiteSaque || 0
                              ).toLocaleString('pt-BR')}
                            </div>
                          </Card.Body>
                        </Card>
                      )}

                      {/* EMPRESTIMO: Valores de contrato */}
                      {isEmprestimo && (
                        <Card>
                          <Card.Body>
                            <Card.Title>Condições do Empréstimo</Card.Title>

                            <div className="card-field">Valor Mínimo Contratado</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorMinContratado?.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Valor Máximo Contratado</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorMaximoContratado?.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Valor Mínimo da Parcela</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorMinParcela?.toLocaleString('pt-BR')}
                            </div>

                            <div className="card-field">Valor Máximo da Parcela</div>
                            <div className="card-text">
                              R$ {valoresSimulacao?.valorMaxParcela?.toLocaleString('pt-BR')}
                            </div>
                          </Card.Body>
                        </Card>
                      )}

                      {/* Convênio – comum */}
                      <Card>
                        <Card.Body>
                          <Card.Title>Convênio</Card.Title>

                          <div className="card-field">Empregador</div>
                          <div className="card-text">
                            {promotoraEmpregador.find(item =>
                              item.id?.toString() === empregador.toString()
                            )?.nome}
                          </div>

                          <div className="card-field">Produto</div>
                          <div className="card-text">
                            {tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.nomeProduto}
                          </div>

                          <div className="card-field">Tabela</div>
                          <div className="card-text">
                            {tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.nome}
                          </div>
                        </Card.Body>
                      </Card>

                      {/* Fatura – somente cartão */}
                      {!isEmprestimo && (
                        <Card style={{ borderRadius: '0px 0px 15px 0px' }}>
                          <Card.Body>
                            <Card.Title>Fatura</Card.Title>

                            <div className="card-field">Dia de Corte</div>
                            <div className="card-text">
                              {tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.diaCorte}
                            </div>

                            <div className="card-field">Dia de Vencimento</div>
                            <div className="card-text">
                              {tabelaFinanciamentos.find(item => item.codigo === idFinanciamentoEscolhido)?.diaVencimento}
                            </div>
                          </Card.Body>
                        </Card>
                      )}
                    </CardGroup>

                  </>
                )}
                <div className="saque">
                  <Row className="mb-3">
                    <Form.Group as={Col} md="2" controlId="validationName">
                      <Form.Label>Valor Parcela</Form.Label>
                      <input type="text" required className="form-control" value={valorParcela} onChange={(e) => handleValorParcela(e.target.value)} />
                    </Form.Group>

                    <Form.Group as={Col} md="2" controlId="validationName">
                      <Form.Label>Valor Solicitado</Form.Label>
                      <input type="text" required className="form-control" value={valorSolicitado} onChange={(e) => handleValorSolicitado(e.target.value)} />
                    </Form.Group>

                    <Form.Group as={Col} md="2" controlId="validationDate">
                      <Form.Label>Data da Simulação</Form.Label>
                      <Form.Control color="gray" type="text" readOnly disabled value={format(new Date(), 'dd/MM/yyyy')} />
                    </Form.Group>

                    <Form.Group as={Col} md='4' controlId="formBasicSelect">
                      <Form.Label>Prazo</Form.Label>
                      <select className="form-select" defaultValue={prazo} value={prazo} onChange={(e) => setPrazo(e.target.value)}
                      >
                        {prazos.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Form.Group>

                    <div className="button-area">
                      <Button variant='primary' onClick={resultadoSimulacaoParcela}>
                        <BiDollar /> Simular</Button>
                    </div>
                  </Row>
                </div>
                {showResultadoSimulacao && !loading ? (
                  <>
                    <div className="header-cards">
                      <b>Resultado Simulação Saque Parcelado</b>
                    </div><CardGroup>
                      <Card style={{ borderRadius: '0px 0px 0px 15px' }}>
                        <Card.Body>
                          <Card.Title>Valores</Card.Title>
                          <div className="card-field">Valor Solicitado</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorSolicitado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          <div className="card-field">Valor IOF</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorIof.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          <div className="card-field">Valor Líquido</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          <div className="card-field">Valor Parcela</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorParcela.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                        </Card.Body>
                      </Card>
                      <Card>
                        <Card.Body>
                          <Card.Title style={{ border: "'black', '1px'" }}>Valores</Card.Title>
                          <div className="card-field">Valor Refin</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorRefin.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          {!isEmprestimo && (
                            <>
                              <div className="card-field">Valor Compra</div>
                              <div className="card-text">R$ {resultadoSimulacaoFinal?.valorCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                      <Card>
                        <Card.Body>
                          <Card.Title>Valores</Card.Title>
                          <div className="card-field">Valor Principal</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorPrincipal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          <div className="card-field">Valor Bruto</div>
                          <div className="card-text">R$ {resultadoSimulacaoFinal?.valorBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                        </Card.Body>
                      </Card>
                      <Card style={{ borderRadius: '0px 0px 15px 0px' }}>
                        <Card.Body>
                          <Card.Title>Taxas</Card.Title>
                          <div className="card-field">Taxa CL a.m.</div>
                          <div className="card-text">{resultadoSimulacaoFinal?.taxaClAM.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                          <div className="card-field">Taxa CL a.a.</div>
                          <div className="card-text">{resultadoSimulacaoFinal?.taxaClAA.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                          <div className="card-field">Taxa CET a.m.</div>
                          <div className="card-text">{resultadoSimulacaoFinal?.taxaCetAM.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                          <div className="card-field">Taxa CET a.a.</div>
                          <div className="card-text">{resultadoSimulacaoFinal?.taxaCetAA.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                        </Card.Body>
                      </Card>
                      <Card>
                        <Card.Body>
                          <Card.Title>Prazos</Card.Title>
                          <div className="card-field">Prazo</div>
                          <div className="card-text">{resultadoSimulacaoFinal?.prazo}</div>
                          <div className="card-field">Primeiro Vencimento</div>
                          <div className="card-text">{dtPrimeiroVencimento}</div>
                          <div className="card-field">Último Vencimento</div>
                          <div className="card-text">{dtUltimoVencimento}</div>
                        </Card.Body>
                      </Card>
                    </CardGroup>
                    {(parseFloat(resultadoSimulacaoFinal?.valorParcela.toFixed(2)!) <= parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && !isEmprestimo) && (
                      <div className="button-area" style={{ marginTop: '1rem' }}>
                        <Button variant='success' type="submit"><BiDollar /> Solicitar Proposta</Button>
                      </div>
                    )}
                    {(parseFloat(resultadoSimulacaoFinal?.valorParcela.toFixed(2)!) <= parseFloat(valoresSimulacao?.valorRMC.toFixed(2)!) && isEmprestimo) && (
                      <div className="button-area" style={{ marginTop: '1rem' }}>
                        <Button variant='success' type="submit"><BiDollar /> Solicitar Proposta</Button>
                      </div>
                    )}
                  </>
                ) : false}
              </>
            ) : false}
          </>
        ) : valorRMC !== '' ? (
          <table
            style={{
              color: 'Black', backgroundColor: '#CCCCCC', borderColor: '#999999',
              borderWidth: '3px', borderStyle: 'Solid', width: '100%'
            }}>
            <tbody>
              <tr>
                <td>Nenhuma Tabela localizada!</td>
              </tr>
            </tbody>
          </table>
        ) : false}
      </form>
    </Container >
  );
} export default CartaoComponent;
